import React from 'react'
import PropTypes from 'prop-types'

const UrgentIcon = (props) => {
  const { width = 20, height = 20, fill = '#183560' } = props
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2176_2205)">
        <path
          d="M13.3156 2H6.68444L2 6.68444V13.3156L6.68444 18H13.3156L18 13.3156V6.68444L13.3156 2ZM16.2222 12.5778L12.5778 16.2222H7.42222L3.77778 12.5778V7.42222L7.42222 3.77778H12.5778L16.2222 7.42222V12.5778Z"
          fill={fill}
        />
        <path
          d="M10.0002 14.4438C10.4911 14.4438 10.8891 14.0458 10.8891 13.5549C10.8891 13.064 10.4911 12.666 10.0002 12.666C9.5093 12.666 9.11133 13.064 9.11133 13.5549C9.11133 14.0458 9.5093 14.4438 10.0002 14.4438Z"
          fill={fill}
        />
        <path
          d="M9.11133 5.55469H10.8891V11.7769H9.11133V5.55469Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_2176_2205">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

UrgentIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
}

export default UrgentIcon
